var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgColumnInsertRight = function SvgColumnInsertRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 30H3a2 2 0 0 1-2-2V10a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v18a2 2 0 0 1-2 2M3 10v18h6V10zM25.365 9l5.586-5.586L29.537 2l-4.172 4.172L21.193 2l-1.414 1.414zM21 30h-6a2 2 0 0 1-2-2V10a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v18a2 2 0 0 1-2 2m-6-20v18h6V10z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h32v32H0z",
    "data-name": "<Transparent Rectangle>",
    style: {
      fill: "none"
    }
  }));
};
export default SvgColumnInsertRight;